import { convertToQueryString } from '@helpers/core/queryString'
import { isFileFormat } from '@helpers/core/isFileFormat'

const JPG_REGEX = /jpe?g/i
const JPEG_REGEX = /jpeg/i

type Format = {
  fm?: string
  fl?: string
}

const getFormat = (format = ''): Format => {
  return {
    // `jpeg` is not a valid value for the `fm` parameter, but `jpg` is.
    fm: JPEG_REGEX.test(format) ? 'jpg' : format || undefined,
    fl: format && format.match(JPG_REGEX) ? 'progressive' : undefined,
  }
}

type ImageConfig = {
  src?: string
  width?: number | null
  quality?: number
  guessedBrowserName?: string
  density?: number
  bg?: string
  format?: string
  height?: number
  ratio?: number
  fit?: string
  focus?: string
}

export const getContentfulImageUrl = (imageConfig: ImageConfig) => {
  const {
    src,
    width = 1,
    quality,
    density = 1,
    bg,
    format,
    height,
    ratio,
    fit,
    focus,
  } = imageConfig

  if (!src) {
    return ''
  }

  if (isFileFormat('svg', src)) {
    return src
  }

  const imageFormat = !format && isFileFormat('jpg', src) ? 'jpg' : format

  const requestFormat = getFormat(imageFormat)

  const params = {
    bg,
    fit,
    f: focus,
    h: height ? (height * density).toString() : undefined,
    w: width ? (width * density).toString() : undefined,
    q: quality?.toString(),
    ...requestFormat,
  }

  if (typeof ratio === 'number' && width) {
    params.h = Math.round(width * ratio * density).toString()
  }

  const query = convertToQueryString(params)

  const connector = src.includes('?') ? '&' : '?'

  return density !== 1
    ? `${src}${connector}${query} ${density}x`
    : `${src}${connector}${query}`
}
